import * as React from "react";
import { IRepertoireStateKeys } from "../../types/IRepertoireStateKeys";
import { EDITABLE_FIELDS, EMPTY_STRING_VALUE, REPERTOIRE_PAGE_FORM_ITEM_SIZE, REPERTOIRE_PAGE_FORM_WIDE_SIZE } from "../../Consts";
import { IMembersPortalStateKeys } from "../../../membersportal/types/IMembersPortalStateKeys";
import ITooltip from "../Tooltip/IToolTip";
import { SearchRegular } from "@fluentui/react-icons";
import { IconButton } from "@fluentui/react";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";

export interface ITextDataInputProps {
    label?: string;
    value?: any;
    changeData: (value: string | boolean | number, fieldName: IRepertoireStateKeys | IMembersPortalStateKeys, isOnBlur?: boolean, index?: number) => void;
    fieldName: IRepertoireStateKeys | IMembersPortalStateKeys;
    useEnterSubmit?: boolean;
    handleKeyDown?: any;
    readOnly?: boolean;
    fieldType?: string;
    maxLength?: number;
    clickPrompt?: boolean;
    onClick?: any;
    textArea?: boolean;
    isHidden: boolean;
    isOnBlurOn?: boolean
    onBlurEvent?: any;
    minValueForNumericField?: number;
    isMandatory?: boolean;
    Width?: number;
    objectKey?:string;
    placeholder?:string;
    onMenuClick?: (value: number) => void;
    searchTypeValue?: number;
    lookupValues?: ILookupDictionary;
}
export interface ISearchTextDataInputProps extends ITextDataInputProps {
    onSearchClick: () => void;
}
interface ITextDataInputState { }

export const SizedTextDataInput = (props: ITextDataInputProps) => {

    if (props.isHidden)
        return null;
    return (props.objectKey==="Agreements"?(<div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE} style={{paddingRight:0}}>
        <TextDataInput {...props} />
    </div>):(<div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE} >
        <TextDataInput {...props} />
    </div>))
}

export const SizedTextDataInputWithSearchType = (props: ITextDataInputProps) => {
    const searchOperators = props?.lookupValues?.SearchOperator?.lookups;
    const defaultItems = [
                            {
                                key: "0",
                                text: searchOperators?.find(op => op.code === "Contains")?.description || "Contains",
                                onClick: () => props.onMenuClick && props.onMenuClick(0),
                            },
                            {
                            
                                key: "2",
                                text: searchOperators?.find(op => op.code === "ExactMatch")?.description || "Exact",
                                onClick: () => props.onMenuClick && props.onMenuClick(2),
                            },
                            {
                                key: "1",
                                text: searchOperators?.find(op => op.code === "StartsWith")?.description || "Begins",
                                onClick: () => props.onMenuClick && props.onMenuClick(1),
                            },
                        ]

    const getSearchOperatorItems = (searchOperators: any[]) => {
        return searchOperators.map(operator => ({
            key: operator.typeID,
            text: operator.description,
            onClick: () => props.onMenuClick && props.onMenuClick(operator.typeID),
        }));
    };

  
    const items = searchOperators ? getSearchOperatorItems(searchOperators) : defaultItems;

    const getDisplayLetter = (value: number) => {
        switch (value) {
            case 0:
                return searchOperators?.find(op => op.code === "Contains")?.description || "Contains";
            case 2:
                return searchOperators?.find(op => op.code === "ExactMatch")?.description || "Exact";
            case 1:
                return searchOperators?.find(op => op.code === "StartsWith")?.description || "Begins";
            default:
                return "";
        }
    };

    if (props.isHidden)
        return null;
    return (props.objectKey==="Agreements"?(<div className={`${REPERTOIRE_PAGE_FORM_ITEM_SIZE} searchTypeAgreementField`}>
        <TextDataInput {...props} />
    </div>):(<div className={REPERTOIRE_PAGE_FORM_ITEM_SIZE} >
         <div className="searchTypeInputRow">
        <div className="searchTypeInputField">
            <TextDataInput {...props} />
        </div>
        <IconButton
                type="button"
                title="Search options"
                ariaLabel="Search options"
                className="searchTypeButton"
                onRenderIcon={() => (
                    <span className="paddingLeftSmall">
                        {`${getDisplayLetter(props.searchTypeValue)}`}
                    </span>
                )}
                menuProps={{
                    items: items
                    }}
                    />
                </div>
    </div>))
}

export const WideTextDataInput = (props: ITextDataInputProps) => {

    if (props.isHidden)
        return null;

    return <div className={REPERTOIRE_PAGE_FORM_WIDE_SIZE}>
        <TextDataInput {...props} />
    </div>
}

export const SearchTextDataInput = (props: ISearchTextDataInputProps) => {

    if (props.isHidden)
        return null;

    const { onSearchClick, ...textDataInputProps } = props;

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                width: "540px",
            }}
        >
            <div style={{ flex: 1 }}>
                <TextDataInput
                    {...textDataInputProps}
                />
            </div>

            <button
                type="button"
                onClick={onSearchClick}
                data-testid={`${props.fieldName}-search-icon`}
                style={{
                    width: "40px",
                    height: "38px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 0,
                    margin: 0,
                    border: "none",
                    borderRadius: "0 4px 4px 0",
                    backgroundColor: "#e5e5e5",
                    cursor: "pointer",
                }}
            >
                <SearchRegular
                    aria-hidden="true"
                    primaryFill="#000000"
                    style={{
                        width: "20px",
                        height: "20px",
                    }}
                />
            </button>
        </div>
    );
}

export default class TextDataInput extends React.PureComponent<
    ITextDataInputProps,
    ITextDataInputState
> {

    constructor(props: ITextDataInputProps) {
        super(props);

        this.state = {};
    }

    render() {
        const {
            label,
            value,
            changeData,
            fieldName,
            handleKeyDown,
            useEnterSubmit,
            readOnly,
            fieldType,
            maxLength,
            onClick,
            clickPrompt,
            textArea,
            isOnBlurOn,
            onBlurEvent,
            minValueForNumericField,
            isMandatory,
            Width,
            objectKey,
            placeholder
        } = this.props;

        const inputType = fieldType === "integer" ? "number" : "text";
        const editableLabel = fieldName === EDITABLE_FIELDS ? "editableLabel" : "";
        const textAlign= (objectKey==="interestPercent"||objectKey==="perDuration")? true :false;
        return (
            <div id="textField">
                {label ? <label className={EMPTY_STRING_VALUE.concat(isMandatory ? " isMandatory " : "", readOnly ? " disabledItem " : "")}>{label}:</label> : null}

                {textArea ?
                    <textarea
                        style={{ minHeight: '50px' }}
                        value={value == null || value == undefined ? '' : value}
                        onChange={event => changeData(event.target.value, fieldName)}
                        disabled={readOnly}
                    />
                    : useEnterSubmit ?
                        <input
                            type={inputType}
                            value={value == null || value == undefined ? '' : value}
                            onChange={event => changeData(event.target.value, fieldName)}
                            onKeyDown={event => handleKeyDown(event, fieldName)}
                            maxLength={maxLength}
                            data-testid={fieldName}
                            placeholder={placeholder}
                        /> : (clickPrompt ?
                            <input
                                type={inputType}
                                value={value == null || value == undefined ? '' : value}
                                onChange={event => changeData(event.target.value, fieldName)}
                                maxLength={maxLength}
                                onClick={event => onClick(fieldName)}
                                data-testid={fieldName}
                                placeholder={placeholder}
                            /> : (readOnly ?
                                <ITooltip
                                    tooltipContent={value == null || value == undefined ? '' : value}
                                    showTooltip={value !== null && value !== undefined}
                                >
                                    <input
                                        className={"disabledItem"}
                                        style={textAlign?{textAlign: 'right'}:{}}
                                        type={inputType}
                                        value={value == null || value == undefined ? '' : value}
                                        onChange={event => changeData(event.target.value, fieldName)}
                                        maxLength={maxLength}
                                        disabled={true}
                                        data-testid={fieldName}
                                        placeholder={placeholder}
                                    /></ITooltip>
                                : (isOnBlurOn) ?
                                    <input
                                        type={inputType}
                                        value={value == null || value == undefined ? '' : value}
                                        onChange={event => changeData(event.target.value, fieldName)}
                                        onBlur={event => onBlurEvent(event.target.value, fieldName, true)}
                                        maxLength={maxLength}
                                        data-testid={fieldName}
                                        placeholder={placeholder}
                                    /> :
                                    <input
                                        type={inputType}
                                        value={value == null || value == undefined ? '' : value}
                                        onChange={event => changeData(event.target.value, fieldName)}
                                        min={(minValueForNumericField == undefined ? '' : minValueForNumericField.toString())}
                                        maxLength={maxLength}
                                        className={editableLabel}
                                        onBlur={event => event.target.setAttribute("type", inputType)}
                                        data-testid={fieldName}
                                        style={{ width: Width + 'px' }}
                                        placeholder={placeholder}
                                    />))
                }
            </div>
        );
    }
}

